import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { Cookie } from "lucide-react";
import { loadGA } from "../lib/analytics";

const KEY = "topacio_cookie_consent";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));
  if (!visible) return null;

  const choose = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, at: Date.now() }));
    setVisible(false);
    if (value === "accepted" && window.__GA_ID) loadGA(window.__GA_ID);
  };

  return (
    <div data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[80] card-brutal p-5 shadow-[6px_6px_0_0_#111]">
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 shrink-0 bg-brand border-2 border-topacio-ink rounded-lg flex items-center justify-center shadow-[2px_2px_0_0_#111]">
          <Cookie className="w-5 h-5 text-topacio-ink" />
        </span>
        <div>
          <p className="font-display font-bold text-sm text-topacio-ink">{t.cookies.title}</p>
          <p className="text-xs text-topacio-faded mt-1 leading-relaxed">{t.cookies.text}</p>
          <div className="flex flex-wrap items-center gap-2 mt-4">
            <button data-testid="cookie-accept-btn" onClick={() => choose("accepted")} className="btn-primary !px-4 !py-2 !text-[11px]">
              {t.cookies.accept}
            </button>
            <button data-testid="cookie-reject-btn" onClick={() => choose("rejected")} className="btn-secondary !px-4 !py-2 !text-[11px]">
              {t.cookies.reject}
            </button>
            <Link to="/cookies" data-testid="cookie-info-link"
              className="text-[11px] font-extrabold uppercase tracking-wider text-topacio-red hover:text-topacio-ink transition-colors">
              {t.cookies.info}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
